import PaymentSaveQRButton from "../payment/PaymentSaveQRButton";
import {
  LoadingIcon,
  SuccessIcon,
  ErrorIcon,
  TimeoutIcon,
} from "./paymentStatusIcons";

const formatCountdown = (ms) => {
  const total = Math.ceil(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
};

export default function PaymentQRCode({ qr, status, remainingMs }) {
  if (status === "creating")
    return (
      <div className="text-center py-4">
        <LoadingIcon />
        <p className="mt-3">กำลังสร้าง QR…</p>
      </div>
    );

  if (status === "timeout")
    return (
      <div className="text-center py-4">
        <TimeoutIcon />
        <p className="mt-3 text-warning">หมดเวลาชำระเงิน</p>
      </div>
    );

  if (status === "error")
    return (
      <div className="text-center py-4">
        <ErrorIcon />
        <p className="mt-3 text-danger">เกิดข้อผิดพลาด</p>
      </div>
    );

  if (status === "success")
    return (
      <div className="text-center py-4">
        <SuccessIcon />
        <p className="mt-3 text-success fw-bold">ชำระเงินสำเร็จ</p>
      </div>
    );

  return qr ? (
    <div className="text-center pb-4">
      <img
        src={`data:image/png;base64,${qr.qr_base64}`}
        alt="QR Payment"
        style={{ maxWidth: 260 }}
      />

      <p className="mt-3 text-muted">สแกนเพื่อชำระเงิน</p>

      <p className="fw-bold text-primary">⏱️ {formatCountdown(remainingMs)}</p>

      <PaymentSaveQRButton qr={qr} />
    </div>
  ) : null;
}
